import { render, staticRenderFns } from "./documents-count-renderer.vue?vue&type=template&id=07b9118a&lang=html"
import script from "./documents-count-renderer.vue?vue&type=script&lang=js"
export * from "./documents-count-renderer.vue?vue&type=script&lang=js"
import style0 from "./documents-count-renderer.vue?vue&type=style&index=0&id=07b9118a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports